/**
 * Returns a URL only when it is safe to expose as a browser navigation target.
 * Invalid and non-HTTP(S) legacy values remain displayable/copyable but not clickable.
 */
export function getSafeExternalUrl(value: string | null | undefined): string | null {
  if (!value) return null;

  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:' ? value : null;
  } catch {
    return null;
  }
}
